import { createUseStyles } from 'react-jss';

import { Breakpoint, FontWeight, mediaQuery } from '../../../../styles';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles<string, { isHorizontal?: boolean }>(
  ({ breakpoints, colors }: ITheme) => ({
    root: {
      textAlign: 'center',
      width: '100%',
      maxWidth: '14.2857rem',
      margin: '0 auto',
    },
    content: {},
    contentInfo: {
      height: (props) => (props?.isHorizontal ? 270 : '100%'),
      [mediaQuery(Breakpoint.Small)]: {
        height: (props) => (props?.isHorizontal ? 250 : '100%'),
      },
    },
    carouselImage: {
      borderRadius: 24,
    },
    image: {
      maxWidth: '8.5714rem',
      margin: '0 auto',

      '& img, & video': {
        width: '100%',
        display: 'inline-block',
        margin: '0 auto',
        verticalAlign: 'top',
      },
    },
    label: {
      color: 'var(--x-text-color-2) !important',
    },
    title: {
      margin: '1.1429rem 0 0.2857rem 0',
      fontWeight: '600 !important',
    },
    description: {
      fontWeight: `${FontWeight.Medium} !important`,
      lineHeight: '24px',
    },
    horizontal: {
      '&$root': {
        maxWidth: '100%',
        margin: '0 0 1.7143rem 0',
        textAlign: 'left',
        display: 'flex',
      },
      '& $content': {
        padding: '5.7143rem 2.8571rem 2.8571rem',
        flexBasis: '45%',
      },
      '& $image': {
        maxWidth: '100%',
        margin: '0',
        padding: '2.8571rem',
        flexBasis: '55%',
      },
      '& $title': {
        fontSize: '4.2857rem',
        fontWeight: '500 !important',
        lineHeight: '5rem',
        margin: '0 0 1.7143rem 0',
      },
      '& $label': {
        fontSize: '1.4286rem',
        lineHeight: '2rem',
        marginBottom: '0.2857rem',
      },

      [mediaQuery(breakpoints.laptop)]: {
        '&$root': {
          marginBottom: '4rem',
        },
        '& $content': {
          flexBasis: '55%',
          padding: '4.2857rem 1.4286rem 1.4286rem',
        },
        '& $image': {
          flexBasis: '45%',
        },
        '& $title': {
          margin: '0.875rem 0',
          fontSize: '2.5714rem !important',
          lineHeight: '3.4286rem !important',
        },
      },
      [mediaQuery(breakpoints.tablet)]: {
        '&$root': {
          display: 'block',
        },
        '& $image, & $content': {
          padding: '0',
        },
        '& $label': {
          margin: '1.7143rem 0 0 0',
        },
        '& $title': {
          margin: '0.5714rem 0',
          fontSize: '2.5714rem !important',
          lineHeight: '3.4286rem !important',
        },
      },
    },
    withImgOnRight: {
      '&$root $content': {
        order: -1,
      },
    },
    controlContainer: {
      marginTop: '53px',

      [mediaQuery(breakpoints.tablet)]: {
        '&$controlContainer': {
          marginTop: '16px',
        },
      },
    },
    control: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid var(--x-accent-2-5)',
      borderRadius: '100%',
      width: '47px',
      height: '47px',
      cursor: 'pointer',
      background: 'none',

      '& + $control': {
        marginLeft: '8px',

        '& > i': {
          left: 'auto',
          right: '-1px',
        },
      },

      '&$control:disabled': {
        opacity: '.4',
      },

      '&:hover:not([disabled])': {
        borderColor: colors.primary,
      },

      '& > i': {
        display: 'inline-block',
        verticalAlign: 'top',
        height: 20,
        color: 'var(--x-text-color-1)',
        position: 'relative',
        left: '-2px',

        '& > svg': {
          fill: 'var(--x-text-color-1)',
        },
      },
    },
  }),
  {
    name: 'card-image',
  },
);

export default useStyles;
